module.exports = __webpack_public_path__ + "img/f11dc14281f3faa4e0e4bf6ee07f401.4510676e.png";